import BlockObject from "../BlockObject";
import {makeObservable, observable} from "mobx";
import {YoutubeBlockObj} from "./YoutubeBlockObj";
import {NormalizedVideoVendor} from "./NormalizedVideo";

export default class VideoBlockObject extends BlockObject implements IVideoBlockObj {
    embedResponsive?: boolean;
    isTitle?: boolean;
    link: string;
    modalId: number;
    video: IVideoObject;
    items: Array<IVideoObject>;
    videoType?: NormalizedVideoVendor;

    constructor(blockType: OrganizationType, initialBlockObj: IVideoBlockObj | undefined) {
        super(blockType, initialBlockObj);

        this.setAttributes(initialBlockObj);

        this.videoType = VideoBlockObject.getVideoType(initialBlockObj?.blockModel.json_data.block.settings.url || "");

        const url = initialBlockObj?.blockModel.json_data.block.settings.url;
        if (this.videoType === NormalizedVideoVendor.YOUTUBE && YoutubeBlockObj.isVideoUrl(url)) {
            this.setAttributes({items: [YoutubeBlockObj.getVideo(initialBlockObj as IVideoBlockObj)]});
        } else if (
            this.videoType === NormalizedVideoVendor.VIMEO ||
            this.videoType === NormalizedVideoVendor.DRIVEGOOGLE ||
            this.videoType === NormalizedVideoVendor.SCHOOLTUBE ||
            this.videoType === NormalizedVideoVendor.YOUTUBE ||
            this.videoType === NormalizedVideoVendor.MYVRSPOT
        ) {
            // youtube videos are the only thing we can load synchronously. everything else fetches data from the video URL page
            this.loadAsync = true;
            this.asyncLoaded = false;
        }

        makeObservable(this, {
            embedResponsive: observable,
            isTitle: observable,
            link: observable,
            video: observable,
            videoType: observable,
        });
    }

    static getVideoType(url: string): NormalizedVideoVendor | undefined {
        if (/youtube\.com/.exec(url) ||
            /youtu\.be/.exec(url)
        ) {
            return NormalizedVideoVendor.YOUTUBE;
        }
        if (/vimeo\.com/.exec(url)) {
            return NormalizedVideoVendor.VIMEO;
        }
        if (/schooltube\.com/.exec(url)) {
            return NormalizedVideoVendor.SCHOOLTUBE;
        }
        if (/myvrspot\.com/.exec(url)) {
            return NormalizedVideoVendor.MYVRSPOT;
        }
        if (/drive\.google\.com/.exec(url) ||
            /docs\.google\.com/.exec(url)
        ) {
            return NormalizedVideoVendor.DRIVEGOOGLE;
        }
    }
}
